import { useContext, useState } from "react";
import professions from "../../../Util/dataModels/professions";
import { AppContext } from "../../../Util/contexts/AppContext";
import MDSpinner from "react-md-spinner";

const Profession = () => {
  const { userData, setUserData, route, displayAuthenticationError } =
    useContext(AppContext);

  const [updateProfessionLoading, setUpdateProfessionLoading] = useState(false);

  const updateProfession = (e) => {
    let professionId = professions.indexOf(e.target.value) + 1;
    setUpdateProfessionLoading(true);
    fetch(`${route}/updateprofession.webapi`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Token: userData.Token,
      },
      body: JSON.stringify({
        customerId: userData.CustomerId,
        professionId,
      }),
    })
      .then((response) => {
        if (response.ok) {
          return response.text();
        } else if (response.status === 401) {
          return displayAuthenticationError();
        } else {
          throw new Error("Error");
        }
      })
      .then(() => {
        let tempUserData = structuredClone(userData);
        tempUserData.Profession = e.target.value;
        setUserData(tempUserData);
      })
      .catch((error) => {
        window.alert(
          "There was an error updating your profession. Please try again later."
        );
        e.target.value = userData.Profession;
      })
      .finally(() => {
        setUpdateProfessionLoading(false);
      });
  };

  return (
    <div className="accountSettingsCard">
      <h3 className="accountSettingsCardTitle">Profession</h3>
      <p className="accountSettingsToggleDescription">
        If you selected the wrong profession when logging in for the first time,
        you can change that here.
      </p>
      <select
        className="accountSettingsDropdown"
        defaultValue={userData.Profession}
        onChange={updateProfession}
        disabled={updateProfessionLoading}
      >
        {professions.map((profession, index) => (
          <option
            key={`settings page profession option - ${profession}`}
            value={profession}
          >
            {profession}
          </option>
        ))}
      </select>
      {updateProfessionLoading && (
        <div className="accountSettingsCardLoaderOverlay">
          <MDSpinner size={35} singleColor={"#fff"} />
        </div>
      )}
    </div>
  );
};

export default Profession;
